import { createSlice } from "@reduxjs/toolkit";

import { checkDocRule, getChargeStatus } from "./thunk";

const initialState = {
  loadingRule: false,
  docRule: "",
  chargesAvailable: false,
};

export const checkDocRulesSlice = createSlice({
  name: "commonApiCall",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checkDocRule.pending, (state) => {
      state.loadingRule = true;
      state.docRules = null;
    });
    builder.addCase(checkDocRule.fulfilled, (state, action) => {
      state.loadingRule = false;
      state.docRule = action.payload?.data[0];
    });
    builder.addCase(checkDocRule.rejected, (state) => {
      state.loadingRule = false;
      state.docRule = null;
    });

    builder.addCase(getChargeStatus.pending, (state) => {
      state.chargesAvailable = false;
    });
    builder.addCase(getChargeStatus.fulfilled, (state, action) => {
      state.chargesAvailable = action.payload.data.length > 0 ? true : false;
    });
    builder.addCase(getChargeStatus.rejected, (state) => {
      state.chargesAvailable = null;
    });
  },
});

// export actions that does not involve api calls

// export reducer
export default checkDocRulesSlice.reducer;
